export default __webpack_public_path__ + "static/media/Predators.d07e082a.png";